import { useState, useEffect } from "react";
import {
  getPublicCurriculums,
  getPrivateCurriculums,
  publishCurriculum,
  updateCurriculum,
  deleteCurriculum,
} from "./../../../../REDUX/Models/curriculums.Model";
import { createNotifi } from "./../../../../REDUX/Models/notifi.Model";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { signOut } from "../../../../REDUX/Slices/users.Slice";
import "./index.scss";

export default function Curriculums({ goBack }) {
  const [privateCurriculums, setPrivateCurriculums] = useState([]);
  const [publicCurriculums, setPublicCurriculums] = useState([]);
  const [inputStates, setInputStates] = useState({});
  const [reload, setReload] = useState(false);
  const dispatch = useDispatch();

  const refreshData = () => setReload((prev) => !prev);

  const handleClick = (id, user_id) => {
    publishCurriculum(id)
      .then(() => {
        createNotifi({
          text: `تم نشر المنهج الخاص بك .. انظر المناهج`,
          user_id,
        });
        refreshData();
      })
      .catch(() => dispatch(signOut()));
  };

  const handleUpdate = (el) => {
    const state = inputStates[el.id];
    if (!state?.subscribers) return;

    updateCurriculum(el.id, {
      title: el.title,
      description: el.description,
      test: el.test,
      public: true,
      subscribers: state.subscribers,
      category_id: el.category_id,
      user_id: el.user_id,
    })
      .then(() => {
        refreshData();
        setInputStates((prev) => ({
          ...prev,
          [el.id]: { ...prev[el.id], subscribers: "" },
        }));
      })
      .catch(() => {
        alert("خطأ تحديث المنهج.");
        window.location.reload();
      });
  };

  const handleNotifi = (el) => {
    const state = inputStates[el.id];
    if (!state?.text) return;

    createNotifi({
      text: state.text,
      user_id: el.user_id,
    });

    setInputStates((prev) => ({
      ...prev,
      [el.id]: { ...prev[el.id], text: "" },
    }));
    alert("تم ارسال اشعار جديد.");
  };

  const handleDelete = (id) => {
    const confirmed = window.confirm("هل انت متأكد من حذف هذا المنهج ؟");
    if (confirmed) {
      deleteCurriculum(id).then(refreshData);
    }
  };

  const handleInputChange = (id, field, value) => {
    setInputStates((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  useEffect(() => {
    getPrivateCurriculums()
      .then((res) => setPrivateCurriculums(res.data.curriculums))
      .catch(() => dispatch(signOut()));

    getPublicCurriculums()
      .then((res) => setPublicCurriculums(res.data.curriculums))
      .catch(() => dispatch(signOut()));
  }, [reload]);

  return (
    <div className="admin-curriculums">
      <div className="container">
        <header>
          <h2>المناهج</h2>
          <p style={{ cursor: "pointer" }} onClick={goBack}>
            اغلاق<i className="fa-light fa-x"></i>
          </p>
        </header>
        <p>* اضغط على اسم المنهج للعرض ..</p>
        <div className="row">
          <div className="in-review">
            <h2>قيد المراجعة {`(${privateCurriculums.length})`}</h2>
            {privateCurriculums.length > 0
              ? privateCurriculums.map((el) => (
                  <div className="curr" key={el.id}>
                    <div className="curr-box">
                      <Link to={`/curriculum/${el.id}`} target="_blank">
                        <p>
                          <span>اسم المنهج: </span>
                          {el.title}
                        </p>
                      </Link>
                      <p>
                        <span>وصف المنهج: </span>
                        {el.description}
                      </p>
                      <p>
                        <span>رابط الاختبار: </span>
                        <Link to={`${el.test}`} target="_blank">
                          الاختبار
                        </Link>
                      </p>
                      <button onClick={() => handleClick(el.id, el.user_id)}>
                        قبول
                      </button>
                      <button onClick={() => handleDelete(el.id)}>حذف</button>
                    </div>
                  </div>
                ))
              : "لا يوجد مناهج قيد المراجعة .."}
          </div>

          <div className="public">
            <h2>مناهج عامة {`(${publicCurriculums.length})`}</h2>
            {publicCurriculums.length > 0
              ? publicCurriculums.map((el) => {
                  const input = inputStates[el.id] || {
                    subscribers: "",
                    text: "",
                  };

                  return (
                    <div className="curr" key={el.id}>
                      <div className="curr-box">
                        <Link to={`/curriculum/${el.id}`} target="_blank">
                          <p>
                            <span>اسم المنهج: </span>
                            {el.title}
                          </p>
                        </Link>
                        <p>
                          <span>وصف المنهج: </span>
                          {el.description}
                        </p>
                        <p>
                          <span>رابط الاختبار: </span>
                          <Link to={`${el.test}`} target="_blank">
                            الاختبار
                          </Link>
                        </p>
                        <label>المشتركين{`(${el.subscribers})`}</label>
                        <input
                          type="number"
                          placeholder="اضافة مشتركين"
                          value={input.subscribers}
                          onChange={(e) =>
                            handleInputChange(
                              el.id,
                              "subscribers",
                              e.target.value
                            )
                          }
                        />
                        <input
                          type="text"
                          placeholder="ارسال اشعار"
                          value={input.text}
                          onChange={(e) =>
                            handleInputChange(el.id, "text", e.target.value)
                          }
                        />
                        <div className="btns">
                          <button
                            disabled={!input.text}
                            onClick={() => handleNotifi(el)}
                          >
                            <i className="fa-light fa-paper-plane"></i>
                          </button>
                          <button
                            disabled={!input.subscribers}
                            onClick={() => handleUpdate(el)}
                          >
                            تحديث
                          </button>
                          <button onClick={() => handleDelete(el.id)}>
                            حذف
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              : "لا يوجد مناهج عامة .."}
          </div>
        </div>
      </div>
    </div>
  );
}
